import { library } from "@fortawesome/fontawesome-svg-core";
import { faEye, faEyeSlash, faClock, faSearch } from "@fortawesome/free-solid-svg-icons";
library.add(faEye, faEyeSlash, faClock, faSearch);
